import { Typeahead } from "@zapier/design-system";

import { Chatbot, Table, tablesAsyncAtom } from "@zapier/canvas-state";
import { useAtomValue } from "jotai";
import { ErrorBoundary } from "../ErrorBoundary";
import { Suspense } from "react";

type Props = {
  selectedId: string | undefined;
  onChange: (item: Table | null | undefined) => void;
  isDisabled?: boolean;
};

function TablesTypeaheadLoader() {
  return (
    <Typeahead<Chatbot>
      aria-label="Search Tables"
      isBusy={true}
      items={[]}
      menuAriaLabel="list of tables"
      getLabelForItem={(item: Table) => item.name || "Untitled Table"}
      onChange={() => {}}
      placeholder="Loading Tables..."
      size="small"
      isDisabled={true}
    />
  );
}

function TablesTypeaheadSuspended({ onChange, selectedId, isDisabled }: Props) {
  const tables = useAtomValue(tablesAsyncAtom);
  const selectedItem = tables.find((table) => table.id === selectedId);

  return (
    <Typeahead
      key={selectedId} // Need this or else if you clear and select the same item, sometimes it won't select
      aria-label="Search Tables"
      autoComplete="off"
      items={tables}
      menuAriaLabel="list of tables"
      getLabelForItem={(item: Table) => item.name || "Untitled Table"}
      onChange={onChange}
      placeholder="Search"
      selectedItem={selectedItem}
      showErrorOnNoResults={false}
      size="small"
      isDisabled={isDisabled}
      openOnFocus={true}
    />
  );
}

export function TablesTypeahead({ onChange, selectedId, isDisabled }: Props) {
  return (
    <ErrorBoundary>
      <Suspense fallback={<TablesTypeaheadLoader />}>
        <TablesTypeaheadSuspended
          onChange={onChange}
          selectedId={selectedId}
          isDisabled={isDisabled}
        />
      </Suspense>
    </ErrorBoundary>
  );
}
